import admin from "./admin";
import { ADD } from "./ApiControllers";

const Logout = () => {
  let res = ADD(admin.token, "logout", {});
  localStorage.removeItem("admin");
  localStorage.removeItem("isChecked");
  localStorage.removeItem("selectedClinic");
  localStorage.removeItem("selectedClinicId");
  localStorage.removeItem("selectedPathology");
  window.location.reload();
  setTimeout(() => {
    window.location.reload("/");
  }, 1000);
  return res;
};

export default Logout;
